import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, branch, renderNothing } from 'recompose';

import LoginForm from 'modules/auth/components/LoginForm';
import { isBrowserSupported } from 'shared/utils/checkMobileDevice';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import BrowserNotSupported from 'modules/auth/components/BrowserNotSupported';
import { getLoginOrganizationDetails } from 'modules/auth/actions/getLoginOrganizationDetails';

import BackgroundLayout from '../../_layouts/BackgroundLayout';
import AuthorizationPageLayout from '../../_layouts/AuthorizationPageLayout';


const LoginPage = () => {
  if (!isBrowserSupported()) {
    return (
      <BackgroundLayout>
        <BrowserNotSupported />
      </BackgroundLayout>
    );
  }

  return (
    <AuthorizationPageLayout>
      <LoginForm />
    </AuthorizationPageLayout>
  );
};


export default compose(
  connect(
    state => ({
      organizationDetailsFetched: state.auth.organizations.fetchTermsAndConditionsStatus === requestsStatuses.success,
    }),
    { getLoginOrganizationDetails },
  ),
  lifecycle({
    componentWillMount() {
      const { organizationDetailsFetched, getLoginOrganizationDetails } = this.props;
      if (!organizationDetailsFetched) getLoginOrganizationDetails();
    },
  }),
  branch(
    ({ organizationDetailsFetched }) => !organizationDetailsFetched,
    renderNothing,
  ),
)(LoginPage);
